module.exports = __webpack_public_path__ + "img/Haier.052862b5.jpg";